import { supabase } from "../../supabaseClient";

class SupaBaseAuth {
  static async loginOrSignUpWithEmail(email, password) {
    try {
      const { error } = await supabase.auth.signInWithPassword({
        email,
        password,
      });

      if (error) {
        if (error.message.includes("Invalid login credentials")) {
          console.log(
            "Utilisateur non trouvé, création d’un nouveau compte..."
          );
          const { data: signUpData, error: signUpError } =
            await supabase.auth.signUp({
              email,
              password,
            });

          if (signUpError) {
            throw new Error(signUpError.message);
          }

          const userId = signUpData.user.id;
          const { error: roleError } = await supabase
            .from("user_roles")
            .insert([{ user_id: userId, role_id: 1 }]);

          if (roleError) {
            throw new Error(
              "Compte créé, mais impossible d'attribuer le rôle 'normal'."
            );
          }

          return "Compte créé avec succès. Vérifiez votre email pour confirmer.";
        }

        throw new Error(error.message);
      }

      return "Connexion réussie.";
    } catch (err) {
      throw new Error(err.message);
    }
  }

  static async logout() {
    const { error } = await supabase.auth.signOut();

    if (error) {
      throw new Error(error.message);
    }
    return "Déconnexion réussie.";
  }

  static async getCurrentUser() {
    const {
      data: { session },
    } = await supabase.auth.getSession();

    if (!session?.user) {
      throw new Error("Aucun utilisateur connecté.");
    }

    return session.user;
  }

  static async loginWithGoogle() {
    try {
      const currentOrigin = window.location.origin;

      const { error } = await supabase.auth.signInWithOAuth({
        provider: "google",
        options: {
          redirectTo: `${currentOrigin}`, // ou juste currentOrigin si t'as pas de page dédiée
        },
      });

      if (error) {
        throw new Error(error.message);
      }

      return "Redirection réussie pour Google Sign In.";
    } catch (err) {
      throw new Error(err.message);
    }
  }
}

export default SupaBaseAuth;
